import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'absoluteUrl',
})
export class AbsoluteUrlPipe implements PipeTransform {
  transform(route?: string): string {
    if (!route) return '';
    return `${window.location.origin}/${route.replace(/^\//, '')}`;
  }
}
